/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlannedFocusDay } from '../../models/planned-focus-day';

export interface GetStudentPlannedFocusDay$Params {
  profileId: string;
  id: string;
}

export function getStudentPlannedFocusDay(http: HttpClient, rootUrl: string, params: GetStudentPlannedFocusDay$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedFocusDay>> {
  const rb = new RequestBuilder(rootUrl, getStudentPlannedFocusDay.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlannedFocusDay>;
    })
  );
}

getStudentPlannedFocusDay.PATH = '/studentprofile/{profileId}/plannedfocusday/{id}';
